import Loading from "src/components/Loading";

interface ConnectionStatusBlockProps {
  connectionStatus: boolean | null;
  isTestingConnection: boolean;
  isLoadingConnectionStatus: boolean;
}

const ConnectionStatusBlock = ({
  connectionStatus,
  isTestingConnection,
  isLoadingConnectionStatus,
}: ConnectionStatusBlockProps) => {
  if (isLoadingConnectionStatus) {
    return <Loading message="Checking Connection Status..." />;
  }

  return (
    <div
      className={`rounded-lg shadow p-6 ${
        connectionStatus === false
          ? "bg-red-50 border-2 border-red-200"
          : connectionStatus === true
            ? "bg-green-50 border-2 border-green-200"
            : "bg-yellow-50 border-2 border-yellow-200"
      }`}
    >
      <h3
        className={`text-lg font-semibold mb-2 ${
          connectionStatus === false
            ? "text-red-900"
            : connectionStatus === true
              ? "text-green-900"
              : "text-yellow-900"
        }`}
      >
        {connectionStatus === false
          ? "Organization Not Connected"
          : connectionStatus === true
            ? "Organization Connected"
            : "Checking Connection Status..."}
      </h3>
      {isTestingConnection ? (
        <Loading message="Testing Connection..." className="justify-start mb-4" />
      ) : connectionStatus === true ? (
        <p className="text-green-800 mb-4">
          Your organization is successfully connected to the EHR system.
        </p>
      ) : (
        <p className="text-red-800 mb-4">
          Your organization is not connected to the EHR system. Please test the connection and fix any configuration issues before proceeding.
        </p>
      )}
    </div>
  );
};

export default ConnectionStatusBlock;
